export default __webpack_public_path__ + "082176e8db6073d24106d6b913b80e12.png";